import { CircularProgress, Grid, Paper } from "@material-ui/core";
import { useGetMechanicalActivitiesQuery } from "features/activity/activitySlice";
import { useGetVehiclesQuery } from "features/vehicles/vehicleSlice";
import { useTitle } from "hooks/useTitle";
import { useSelector } from "react-redux";
import { arrayToObject } from "utils/object-util";
import { useGetReadinessQuery } from '../../../../features/vehicles/readiness/readinessSlice';
import SlaChartCard from "./SlaChartCard/SlaChartCard";
import SlaListDialog from "./SlaChartCard/SlaListDialog";
import SlaPerLotCard from "./SlaPerLotCard/SlaPerLotCard";
import WashCountCard from "./WashCountCard/WashCountCard";
import { washDashboardStyles } from "./WashDashboardStyles";

const WashDashboardPage = () => {
    useTitle('Wash Dashboard');

    let { data: mechanicalActivities, error: mechanicalActivitiesError, refetch, isFetching: isLoadingMechanicalActivities } = useGetMechanicalActivitiesQuery();
    let { data: vehiclesReadiness, error: vehiclesReadinessError, isFetching: isLoadingVehiclesReadiness } = useGetReadinessQuery({ calcWashSla: true });
    let { data: vehiclesData, error: vehicleError, isFetching: isFetchingVehicles, refetch: refetchVehicles } = useGetVehiclesQuery({ includeHistory: true });
    const vehiclesDataByVehicleId = arrayToObject(vehiclesData);
    const { filters } = useSelector(state => state.dashboardState);

    const washes = mechanicalActivities?.filter(wash => {
        return !!(
            wash.activityItemId == 23 &&
            (!filters?.lotId?.length || filters?.lotId?.includes(wash.lotId)) 
            && (filters.isDefaultAccount? (!filters.clientId || filters.clientId == wash.clientId) 
            : (!filters.clientAccountId || filters.clientAccountId == wash.clientAccountId))
        );
    });

    let filteredVehicleData = vehiclesData?.filter(v =>
        (!filters.lotId?.length || filters.lotId.includes(v.lotId))
        && (filters.isDefaultAccount? (!filters.clientId || filters.clientId == v.clientId) 
        : (!filters.clientAccountId || filters.clientAccountId == v.clientAccountId))
    );


    const filteredReadiness = vehiclesReadiness?.filter(r => r.underSlaInLastCycle != null &&
        (!filters?.lotId?.length || filters?.lotId?.includes(r.lotId))
        && (filters.isDefaultAccount? (!filters.clientId || filters.clientId == r.clientId) 
        : (!filters.clientAccountId || filters.clientAccountId == r.clientAccountId))
    );

    const domiciled = filteredVehicleData?.filter(v => v.domicileLot && v.domicileLot === v.lotId);
    const notDomiciled = filteredVehicleData?.filter(v => !v.domicileLot);

    const classes = washDashboardStyles();


    return (
        <>

            <Grid container direction="row" spacing={2}>
                {/* <Grid item xs={4} >
                    <Paper elevation={1} className={classes.card}>
                        <PendingWashCard washes={washes} vehicleLookup={vehiclesDataByVehicleId} loading={isLoadingMechanicalActivities} />
                    </Paper>
                </Grid>
                <Grid item xs={4} >
                    <Paper elevation={1} className={classes.card}>
                        <Grid className={classes.wrapper} container direction="column">
                            {isFetchingVehicles &&
                                <CircularProgress
                                    size='1em'
                                    style={{ position: 'absolute', right: '0', bottom: 0 }}
                                />}
                            <Grid item className={classes.count}>{domiciled?.length ?? 0}</Grid>
                            <Grid item><h3 className={classes.text}>Domiciled Vehicles</h3></Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={4} >
                    <Paper elevation={1} className={classes.card}>
                        <Grid className={classes.wrapper} container direction="column">
                            {isFetchingVehicles &&
                                <CircularProgress
                                    size='1em'
                                    style={{ position: 'absolute', right: '0', bottom: 0 }}
                                />}
                            <Grid item className={classes.count}>{notDomiciled?.filter(v => !v.domicileLot || (v.domicileLot !== v.lotId))?.length ?? 0}</Grid>
                            <Grid item><h3 className={classes.text}>Non-Domiciled Vehicles</h3></Grid>
                        </Grid>
                    </Paper>
                </Grid> */}
                <Grid item xs={3}>
                    <Paper className={classes.card} elevation={1}>
                        <Grid container direction="column" className={classes.wrapper}>
                            {isLoadingMechanicalActivities &&
                                <CircularProgress
                                    size='1em'
                                    style={{ position: 'absolute', right: '0', bottom: 0 }}
                                />}
                            <Grid item>
                                <Grid container alignItems="center">
                                    {/* <Grid item><img src="/icons/icon-inspect.svg" className={classes.icon} /></Grid> */}
                                    <Grid item> <h3 className={classes.subTitle}>Monthly Washes</h3></Grid>
                                </Grid>
                                <Grid>
                                    <WashCountCard washes={washes} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                <Grid item xs={6}>
                    <Paper className={classes.card} elevation={1}>
                        <Grid container direction="column" className={classes.graphWrapper}  >
                            {isLoadingVehiclesReadiness &&
                                <CircularProgress
                                    size='1em'
                                    style={{ position: 'absolute', right: '0', bottom: 0 }}
                                />}
                            <Grid item container justifyContent="space-between" >
                                <h3 className={classes.subTitle}> Assets Per Lot Within SLA This Cycle</h3>
                            </Grid>
                            <Grid item style={{ flexGrow: 1 }}>
                                <SlaPerLotCard vehiclesReadiness={filteredReadiness} />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                {/* <Authorize profile={permissionProfiles.DASHBOARD.WASH_DASHBOARD_COMPLIANCE_GRAPH}> */}

                {/* </Authorize> */}
                {/* <Authorize profile={permissionProfiles.DASHBOARD.WASH_SLA}> */}
                <Grid item xs={3}>
                    <Paper className={classes.card} elevation={1}>
                        <Grid container direction="column" className={classes.graphWrapper} >
                            {isLoadingVehiclesReadiness &&
                                <CircularProgress
                                    size='1em'
                                    style={{ position: 'absolute', right: '0', bottom: 0 }}
                                />}
                            <Grid container justifyContent="space-between" >
                                <h3 className={classes.subTitle}>Washes Within SLA in Cycle</h3>
                                <SlaListDialog washSlaData={filteredReadiness} />
                            </Grid>
                            <Grid item style={{ flexGrow: 1 }}>
                                <SlaChartCard vehiclesReadiness={filteredReadiness} />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                {/* </Authorize> */}
            </Grid>

        </>
    );
};

export default WashDashboardPage;
